// extracted by mini-css-extract-plugin
export var active = "Reviews-module--active--3ff6e";
export var image = "Reviews-module--image--b5ee8";
export var imageAndName = "Reviews-module--imageAndName--66bc3";
export var justOneReview = "Reviews-module--justOneReview--f0158";
export var marginBottomExtraSmall = "Reviews-module--marginBottomExtraSmall--c6ef9";
export var marginBottomSmall = "Reviews-module--marginBottomSmall--9ba36";
export var marginTopExtraSmall = "Reviews-module--marginTopExtraSmall--9f398";
export var marginTopSmall = "Reviews-module--marginTopSmall--b7216";
export var mobileImage = "Reviews-module--mobileImage--09b72";
export var nameFlex = "Reviews-module--nameFlex--2370b";
export var newLargerStyle = "Reviews-module--newLargerStyle--48b94";
export var noTotalRating = "Reviews-module--noTotalRating--4efff";
export var personName = "Reviews-module--personName--aa8c6";
export var rating1 = "Reviews-module--rating1--81bf8";
export var rating15 = "Reviews-module--rating15--f0fba";
export var rating2 = "Reviews-module--rating2--c6ee6";
export var rating25 = "Reviews-module--rating25--b6b5b";
export var rating3 = "Reviews-module--rating3--0db07";
export var rating35 = "Reviews-module--rating35--83597";
export var rating4 = "Reviews-module--rating4--8cffd";
export var rating45 = "Reviews-module--rating45--954c0";
export var review = "Reviews-module--review--871b4";
export var reviewImage = "Reviews-module--reviewImage--f45c3";
export var reviewText = "Reviews-module--reviewText--e242f";
export var reviews = "Reviews-module--reviews--cb859";
export var section = "Reviews-module--section--e46d4";
export var starRating = "Reviews-module--starRating--8bb27";
export var textUnderName = "Reviews-module--textUnderName--ec5ce";
export var topText = "Reviews-module--topText--91f7b";
export var totalRating = "Reviews-module--totalRating--a95d7";
export var totalRatingWrapper = "Reviews-module--totalRatingWrapper--c62df";